export default "__VITE_ASSET__DUAP_eRX__"